import React, { Suspense, lazy } from 'react';
import { Loader } from '@growthaxl/web-foundation';
import { useShellStore } from '../../../../shell/store/shellStore';
import { ESAChatViewBoundary } from './ESAChatViewBoundary';

import { ESABriefing } from '../briefing/ESABriefing';
import { ESAChatView } from '../chat/ESAChatView';

const ESAThreadListView = lazy(() =>
  import('../threads/ESAThreadListView').then(m => ({ default: m.ESAThreadListView }))
);

const InboxView = lazy(() =>
  import('../inbox/InboxView').then(m => ({ default: m.InboxView }))
);

const ResolvingView = lazy(() =>
  import('../resolve/ResolvingView').then(m => ({ default: m.ResolvingView }))
);

function PanelSkeleton() {
  return (
    <div className="flex flex-col items-center justify-center gap-2 p-4 opacity-40" aria-label="Loading panel">
      <Loader />
    </div>
  );
}

/**
 * View switcher — reads shellStore.esaPanelMode and renders the appropriate view.
 * Wraps the chat view in ESAChatViewBoundary (DR-15).
 */
export function ESAPanelRouter(): React.ReactElement {
  const mode = useShellStore(s => s.esaPanelMode);

  return (
    <Suspense fallback={<PanelSkeleton />}>
      {mode === 'briefing' && <ESABriefing />}
      {mode === 'chat' && (
        <ESAChatViewBoundary>
          <ESAChatView />
        </ESAChatViewBoundary>
      )}
      {mode === 'thread-list' && <ESAThreadListView />}
      {mode === 'inbox' && <InboxView />}
      {mode === 'resolve' && <ResolvingView />}
    </Suspense>
  );
}
